import React from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import "react-phone-input-2/lib/style.css";
import { FaArrowRight } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../../redux/actions/CartActions";
import FormalityHeader from "../../../components/header/FormalityHeader";
import "../../styles/flow-form.css";

function ImportationSectorActivityName() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const cart = useSelector((state) => state.cart);

  // Validation schema
  const validationSchema = Yup.object().shape({
    sectorActivity: Yup.string().required("Le secteur d'activité est requis"),
  });

  const handleSubmit = async (values) => {
    await dispatch(
      addToCart({
        sectorActivity: values.sectorActivity,
      })
    );

    navigate("/importation-business-name");
  };

  return (
    <div className="legacy-flow">
      <FormalityHeader from={cart.from} />

      {/* Title Section */}
      <div className="container my-3 text-center" style={{ maxWidth: "800px" }}>
        <h3 className="text-2xl font-semibold">
          Quel est le{" "}
          <span style={{ color: "#FF5500" }}>Secteur d'activité </span>
          de votre {cart?.businessType} ?
        </h3>
      </div>

      {/* Form Section */}
      <div className="container mt-3 d-flex justify-content-center">
        <Formik
          initialValues={{
            sectorActivity: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values) => {
            handleSubmit(values);
          }}
        >
          {({ setFieldValue, errors, touched, values }) => (
            <Form className="w-100" style={{ maxWidth: "500px" }}>
              <div className="mb-3">
                <Field
                  name="sectorActivity"
                  type="text"
                  className="form-control"
                  placeholder="Secteur d'activité"
                  style={{ height: "50px" }}
                />
                {errors.sectorActivity && touched.sectorActivity && (
                  <div className="text-danger">{errors.sectorActivity}</div>
                )}
              </div>

              <div className="d-flex justify-content-center">
                <button
                  type="submit"
                  className="btn btn-primary"
                  style={{
                    backgroundColor: "#051259",
                    borderRadius: "100px",
                    color: "#fff",
                    width: "180px",
                    padding: "15px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  Suivant
                  <FaArrowRight style={{ marginLeft: "8px" }} />
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
}

export default ImportationSectorActivityName;
